<script lang="ts">
    import { getDBEntry } from "../../../api"
    import Select from "./Select.svelte"

    export let field: TaskStepField<"vehicleSelect">,
        value: {
            id: string
            categoryId: string
        } = {
            id: "",
            categoryId: "",
        }
    if (!value) value = { id: "", categoryId: "" }
    let selectedVehicleObject: Vehicle = null
    $: value.id
        ? getDBEntry("vehicle", { _id: value.id }).then((vehicle) => {
            if(!vehicle) return 
              if (value.categoryId !== vehicle.vehicleCategory) value.categoryId = vehicle.vehicleCategory
              selectedVehicleObject = vehicle
          })
        : (function () {
              selectedVehicleObject = null
          })()
</script>

<div class="grid">
    <div class=" col-8">
        {#key selectedVehicleObject?.id}
            <Select
                field="{{
                    widget: 'select',
                    label: 'Fahrzeugkategorie',
                    options: {
                        endpoint: 'vehicleCategory',
                        params: {
                            filter: selectedVehicleObject ? { _id: selectedVehicleObject.vehicleCategory } : {},
                        },
                        mapping: {
                            id: 'id',
                            name: 'name',
                        },
                    },
                }}"
                bind:value="{value.categoryId}"
            />
        {/key}
    </div>
    <div class=" col-4">
        {#key value.categoryId}
            <Select
                field="{{
                    widget: 'select',
                    label: 'Fahrzeug',
                    options: {
                        endpoint: 'vehicle',
                        params: {
                            filter: value.categoryId
                                ? {
                                      vehicleCategory: value.categoryId,
                                      active: true,
                                  }
                                : { active: true },
                        },
                        mapping: {
                            id: 'id',
                            name: 'name',
                        },
                    },
                }}"
                bind:value="{value.id}"
            />
        {/key}
    </div>
</div>

<style lang="less">
    .grid {
        gap: 0.6rem;
        & > div {
            overflow: visible;
        }
    }
</style>
